<div class="fullbgblu" id="popup-inline-{{customName}}">
    <div>
        <div class="{{customClass}}">
            <button type="button" class="close" clickable (click)="doClose()" aria-label="Close">
                <svg viewBox="0 0 16 16"xmlns="http://www.w3.org/2000/svg">
                    <g data-name="Group 14012" id="Group_14012" transform="translate(-5670.304 -485.804)">
                        <path d="M12,14a1.994,1.994,0,0,1-1.414-.586l-12-12a2,2,0,0,1,0-2.828,2,2,0,0,1,2.828,0l12,12A2,2,0,0,1,12,14Z" data-name="Linie 325" fill="#004A63" id="Linie_325" transform="translate(5672.304 487.804)"></path>
                        <path d="M0,14a1.994,1.994,0,0,1-1.414-.586,2,2,0,0,1,0-2.828l12-12a2,2,0,0,1,2.828,0,2,2,0,0,1,0,2.828l-12,12A1.994,1.994,0,0,1,0,14Z" data-name="Linie 326" fill="#004A63" id="Linie_326" transform="translate(5672.304 487.804)"></path>
                    </g>
                </svg>
              </button>            
            <ng-content></ng-content>
        </div>
    </div>
</div>